import React from "react";
import { FastField } from "formik";
import MuiAutocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

export default function Autocomplete({
  name,
  label,
  options = [],
  disabled = false,
  size = "small",
  multiple = false,
  freeSolo = false,
  openOnFocus = false,
  getOptionLabel = (option) => option?.label || option || "",
  isOptionEqualToValue,
  placeholder,
  ...props
}) {
  const defaultIsOptionEqualToValue = (option, value) => {
    if (typeof value === "string") return option?.value === value;
    return option?.value === value?.value;
  };

  return (
    <FormControl fullWidth variant="outlined" size={size}>
      <FastField name={name} disabled={disabled}>
        {({ field, form, meta }) => {
          const error = (meta.touched || form.submitCount > 0) && meta.error;

          return (
            <>
              <MuiAutocomplete
                {...props}
                data-id={field.name}
                id={field.name}
                options={options}
                value={field.value || (multiple ? [] : null)}
                multiple={multiple}
                freeSolo={freeSolo}
                disabled={disabled}
                openOnFocus={openOnFocus}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue || defaultIsOptionEqualToValue}
                onChange={(event, newValue) => {
                  if (freeSolo && newValue && typeof newValue === "object" && "value" in newValue) {
                    form.setFieldValue(field.name, newValue.value);
                  } else {
                    form.setFieldValue(field.name, newValue);
                  }
                }}
                onInputChange={freeSolo ? (event, newInputValue, reason) => {
                  if (reason === 'input') {
                    form.setFieldValue(field.name, newInputValue);
                  }
                } : undefined}
                onBlur={() => {
                  form.setFieldTouched(field.name, true);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    error={!!error}
                    variant="outlined"
                    size={size}
                  />
                )}
              />
              
              {error && (
                <FormHelperText htmlFor={field.name} error={!!error}>
                  {error}
                </FormHelperText>
              )}
            </>
          );
        }}
      </FastField>
    </FormControl>
  );
}
